import * as React from 'react';
import { DefaultButton, FontIcon, mergeStyles, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton, ProgressIndicator, Stack, Text, useTheme } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as Services from '../../../../../Services/Services';
import { IStatusMessage } from '../../../../../Models/IStatusMessage';
import { emptyEvent, IEvent } from '../../../../../Models/Event/IEvent';
import { IEventApi } from '../../../../../Services/API/Event/IEventApi';
import { EventPropertiesView } from './EventPropertiesView';
import { IEventType } from '../../../../../Models/EventTypes/IEventType';
import { IAgeGoup } from '../../../../../Models/AgeGroups/IAgeGroup';
import { IRoom } from '../../../../../Models/Rooms/IRoom';
import { IEventTypeApi } from '../../../../../Services/API/EventType/IEventTypeApi';
import { IRoomApi } from '../../../../../Services/API/Room/IRoomApi';
import { IAgeGroupApi } from '../../../../../Services/API/AgeGroup/IAgeGroupApi';
import { backendUrl } from '../../../../../Services/ConfigureService';
import { IAppStore } from '../../../../../Stores/IAppStore';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { IUserProfile } from '../../../../../Models/Profile/IUserProfile';

interface IEventPropertiesProps {
    item: IEvent;
    isOpen: boolean;
    close: () => void;
    refresh: (id: number) => void;
    profile: IUserProfile;
}

export const EventProperties: React.FunctionComponent<IEventPropertiesProps> = (props) => {

    const [isLoading, setIsLoading] = useBoolean(false);
    const [editItem, setEditItem] = React.useState<IEvent>(emptyEvent());
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [isFormValid, setIsFormValid] = React.useState(false);

    const [eventTypes, setEventTypes] = React.useState<IEventType[]>([])
    const [ageGroups, setAgeGroups] = React.useState<IAgeGoup[]>([])
    const [rooms, setRooms] = React.useState<IRoom[]>([])


    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    React.useEffect(() => {
        setEditItem(props.item);
        setIconUrl(backendUrl() + `api/Event/GetProfileImageNoCache/${props.item.id}?time=${Date.now().toString()}`);
    }, [props.item]);

    React.useEffect(() => {
        console.log(editItem);
    }, [editItem]);


    const propertyChanged = (key: string, value: any) => {
        setEditItem({ ...editItem, [key]: value });
        console.log("key:{0}, value:{1}", key, value);

    }

    const loadEventTypes = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventTypeApi>(Services.EventTypeApi);
        const eventType = await eventTypeApi.getEventTypes(false);

        if (eventType.isSuccess && eventType.data) {
            setStatusMessage({ message: eventType.message, type: MessageBarType.success });
            setEventTypes(eventType.data);
        }
        else {
            setStatusMessage({ message: eventType.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadAgeGroups = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IAgeGroupApi>(Services.AgeGroupApi);
        const groups = await ageGroupApi.getAgeGroups("");

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setAgeGroups(groups.data);
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadRooms = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const ageGroupApi = Services.ServicesProvider.GetService<IRoomApi>(Services.RoomApi);
        const groups = await ageGroupApi.getRooms("");

        if (groups.isSuccess && groups.data) {
            setStatusMessage({ message: groups.message, type: MessageBarType.success });
            setRooms(groups.data);
        }
        else {
            setStatusMessage({ message: groups.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        loadRooms();
        loadEventTypes();
        loadAgeGroups();
    }, [])

    const updateEvent = async (event: IEvent) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventApi.updateEvent(event);

        if (result.isSuccess) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            var success = true;
            if (iconFile) {
                const r = await uploadImageIcon(props.item.id, iconFile)
                success = r.isSuccess;
            }
            if (success) {
                await props.refresh(editItem.id);
                props.close();
            }
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const createEvent = async (event: IEvent) => {

        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventApi= Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventApi.createEvent(event);

        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            var success = true;
            if (iconFile) {
                const r = await uploadImageIcon(props.item.id, iconFile)
                success = r.isSuccess;
            }
            if (success) {
                await props.refresh(result.data);
                props.close();
            }
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const [iconUrl, setIconUrl] = React.useState<any>();
    const [iconFile, setIconFile] = React.useState<File>();
    const uploadImageIcon = async (eventId: number, file: File) => {

        const ageGroupApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await ageGroupApi.uploadProfileImage(eventId, file);
        if (result.isSuccess && result.data) {
            setIconUrl(backendUrl() + `api/Event/GetProfileImage/${eventId}`);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        return result;
    }

    return (
        <>
            {props.isOpen ?
                <Panel
                    isOpen={props.isOpen}
                    onDismiss={props.close}
                    type={PanelType.medium}
                    closeButtonAriaLabel="Zavřít">
                    <Stack>
                        <Stack horizontal>
                            <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                                <FontIcon iconName="Event" className={iconClass} />
                            </Stack>

                            <Stack horizontal verticalAlign="center">
                                <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">                                    
                                    {props.item.id === 0 ? "Vytvoření nové události" : props.item.name}
                                </Text>
                            </Stack>
                        </Stack>
                        <EventPropertiesView
                            profile={props.profile}
                            saveEvent={() => editItem.id > 0 ? updateEvent(editItem) : createEvent(editItem)}
                            close={props.close}
                            isValid={isFormValid}
                            eventTypes={eventTypes}
                            ageGroups={ageGroups}
                            rooms={rooms}
                            valid={setIsFormValid}
                            item={editItem}
                            propertyChanged={propertyChanged}
                            isLoading={isLoading}
                            setIcon={setIconFile}
                            setIconUrl={setIconUrl}
                            IconUrl={iconUrl}
                            loadImage={() => { } }
                        />

                        <Stack styles={{ root: { height: 10 } }}>
                            {isLoading ? <ProgressIndicator /> : null}
                        </Stack>
                        {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
                    </Stack>
                </Panel> : null
            }
        </>)
}



const EmailChangeToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,
    

});

const EmailChangeDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(EmailChangeToProps, EmailChangeDispatchToProps)(EventProperties);


